import equal from "fast-deep-equal";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { UserVenue } from "sweet-global";
import Button from "sweet-web/components/universal/Button";
import Input from "sweet-web/components/universal/Input";
import PhoneNumberInput from "sweet-web/components/universal/Input/PhoneNumberInput";
import ProfileImageInput from "sweet-web/components/universal/Input/ProfileImageInput";
import { Form } from "sweet-web/components/universal/View";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { UpdateUser } from "sweet-web/redux/user/actions";

const InputRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & RouteComponentProps;

const Account: React.FC<Props> = props => {
  const [user, setUser] = useState(props.user);
  useEffect(() => {
    setUser(props.user);
  }, [props.user]);

  const onSubmit = e => {
    e.preventDefault();
    props.UpdateUser(user);
  };

  return (
    <Form onSubmit={onSubmit}>
      <ProfileImageInput value={user.image} />
      <InputRow>
        <Input
          title={"First Name"}
          value={user.firstName}
          style={{ flex: 1, marginRight: 5 }}
          onChange={value => {
            setUser({
              ...user,
              firstName: value
            });
          }}
        />
        <Input
          title={"Last Name"}
          value={user.lastName}
          style={{ flex: 1, marginLeft: 5 }}
          onChange={value => {
            setUser({
              ...user,
              lastName: value
            });
          }}
        />
      </InputRow>
      <Input
        title={"Email"}
        value={user.emailAddress}
        onChange={value => {
          setUser({
            ...user,
            emailAddress: value
          });
        }}
      />

      <PhoneNumberInput
        value={user.phoneNumber}
        onChange={value => {
          setUser({
            ...user,
            phoneNumber: value
          });
        }}
      />

      <Button
        submit={true}
        loading={props.loading}
        disabled={equal(props.user, user)}
        title="Update Account"
      />
    </Form>
  );
};

const mapState = (state: RootState) => ({
  user: selectors.user(state),
  loading: selectors.isUpdatingUser(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      UpdateUser
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Account);
